import { InsuredDO } from './';
export class HealthEAppUIDO {

    public id: Number;

    public policyId:Number;
    //owner
    public ownerGuid: any = null;
    public ownerId: any = null;
    public ownerNameCd: any = null;
    public ownerGenderCd: any = null;
    public ownerDOB: any = null;
    public ownerRole = "OWNER"
    public ownerAddressList = [];
    public ownerContactList = [];
    public ownerEmailList = [];
    public ownerIdentityList = [];
    public ownerType: any = null;
    public ownerOrganisationName: any = null;
    public ownerContactPersonName: any = null;

    //payer
    public payerGuid: any = null;
    public payerId: any = null;
    public payerNameCd: any = null;
    public payerGenderCd: any = null;
    public payerDOB: any = null;
    public sourceOfIncomeCd: any = null;
    public paymentMethodCd: any = null;
    public paymentFrequencyCd: any = null;
    public payerAccountNumberCd: any = null;
    public accountHolderNameCd: any = null;
    public payerRole = "PAYER"
    public payerAddressList = [];
    public payerContactList = [];
    public payerEmailList = [];
    public payerIdentityList = [];
    public payerOccupationList = [];
    public payerType: any = null;
    public payerOrganisationName: any = null;
    public payerContactPersonName: any = null;

    //coverage
    public policyStartDate: any = null;
    public policyExpiryDate: any = null;
    public term: number = null;

    public discount: any = 0;

    public selectedProduct: any = null;
    public selectedPlan: any = null;
    public package: any = null

    //insuredDO
    public insuredMembers: InsuredDO[] = [];

    public questionsList: any = [];
    public isEditMode = null;
    public isUIDO = true;
    public sumInsured: Number = null;

    public startDate: any = null;
    public endDate: any = null;
    public baseProductCd: any = null;

    public ratingType: any = null;
    public products: any = [];
    public scheduleList: any = [];
    public baseProductTypeCd: any =null
    public productPlanOptionCd: any = null;
    //client address do
    //client contact do
    //client email do
    //entity do
    //person do
    //policy beneficiary do
    //PersonEmploymentDO
    //PersonIdentityDO
    //ClientDO
    //PolicyCoverage
    //PolicyDO

}